<template>
    <div>
        <sticky :document="document" />
        <banner :document="document" :model="model" />
        <preamble :document="document" :model="model" />
        <lender-content :document="document" :model="model" />
        <user-ratings :document="document" />
        <faq 
            :title="$translate('card_common_questions_about', 'Vanliga frågor om {title}')
                .replace('{title}', document.data.title)" 
            :questions-and-answers="faq" 
        />
        <site-wide-links footer-id="body" />
    </div>
</template>
<script>
import Sticky from '@/components/StickyCTA.vue';
import Banner from '@/components/pages/lender/Banner.vue';
import Preamble from '@/components/pages/lender/Preamble.vue';
import LenderContent from '@/components/pages/lender/LenderContent.vue';
import UserRatings from '@/components/pages/lender/UserRatings.vue';
import Faq from '@/components/Faq.vue';
export default {
    components: {
        Banner,
        Preamble,
        LenderContent,
        Sticky,
        UserRatings,
        Faq
    },
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        model() {
            return new this.$models.Loan(this.document);
        },
        faq() {
            return this.document.data.faq
                .filter(item => this.$validateText(item.question) && this.$validateText(item.answer));
        }
    }
};
</script>